export default __webpack_public_path__ + "static/media/Layer 34.58719bb5.jpg";